<template>
  <div class="MusicBox" v-if="Music.url" @click="PlayerMusic">
    <span class="icon iconfont iconyinle MusicIcon" :class="{MusicIconPlay:isPlay}"></span>
    <audio id="MusicPlayer" :src="Music.url"></audio>
  </div>
</template>

<script>
var self;
export default {
  name: 'Music',
  props:["Music"],
  data () {
    return {
      isPlay:false,
      PlayData:null
    }
  },
  created () {
    self = this;
  },
  methods:{
    PlayerMusic () {
      if(!self.isPlay){
        self.isPlay = true;
        self.PlayData = document.getElementById("MusicPlayer");
        self.PlayData.currentTime = 0;  //重新播放
        setTimeout(function(){
          self.PlayData.play();

          //音频播放完毕
          self.PlayData.addEventListener('ended', function () {
            self.isPlay = false;
          }, false);

        },300)
      }else{
        self.isPlay = false;
        self.PlayData.pause();
      }
    }
  }
}
</script>

<style scoped>
  .MusicBox{
    top:.4rem;
    color:#FFF;
    right:.4rem;
    opacity: .8;
    width:1.2rem;
    height:1.2rem;
    z-index: 1000;
    position: fixed;
    text-align: center;
    border:2px solid #FFF;
    border-radius: 1.2rem;
    background: rgba(0,0,0,0.5);
    box-shadow: 0 0 5px rgba(100,100,100,0.5);
  }
  .MusicIcon{
    position: absolute;
    left:0;right:0;
    line-height: 1.2rem;
    font-size:.8rem;
  }
  .MusicIconPlay{
    animation:rotate 6s infinite;
    -webkit-animation:rotate 6s infinite; /*Safari and Chrome*/
    animation-timing-function:linear;
  }
  @keyframes rotate{
  	0%{
  	    -webkit-transform: rotate(0deg);
  	    -ms-transform: rotate(0deg);
  	    transform: rotate(0deg);
  	}
  	100% {
  	    -webkit-transform: rotate(360deg);
  	    -ms-transform: rotate(360deg);
  	    transform: rotate(360deg);
  	}
  }
  @-webkit-keyframes rotate{
  	0%{
  	    -webkit-transform: rotate(0deg);
  	    -ms-transform: rotate(0deg);
  	    transform: rotate(0deg);
  	}
  	100% {
  	    -webkit-transform: rotate(360deg);
  	    -ms-transform: rotate(360deg);
  	    transform: rotate(360deg);
  	}
  }
</style>



// WEBPACK FOOTER //
// src/components/Music.vue